
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import NewsSection from './components/NewsSection';
import ApproachSection from './components/ApproachSection';
import StatsSection from './components/StatsSection';
import ColumnSection from './components/ColumnSection';
// import TestimonialsSection from './components/TestimonialsSection';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <NewsSection />
        <ApproachSection />
        <StatsSection />
        <ColumnSection />
        {/* <TestimonialsSection /> */}
      </main>
      <Footer />
    </div>
  );
};

export default Home;
